export const FormNameStyle = {
    fontSize: '0.9rem',
    fontWeight: '700',
    justifySelf: 'right',
    height: '100%',
    p: 1,
};

// inline styles for vertical alignment
export const FormValueSx = {
    pr: 1,
    alignItems: 'center',
    display: 'flex',
};

export const calloutStyle = {
    m: 2,
    p: 3,
    backgroundColor: 'var(--appbar-bg-color)',
    borderColor: 'var(--outline-color)',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 2,
    fontStyle: 'italic',
    fontSize: '0.85rem',
    color: 'var(--text-secondary-color)',
};
